exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-editor-container{padding:32px;position:relative}.dashboard-editor-container .github-corner{position:absolute;top:0px;border:0;right:0}.dashboard-editor-container .chart-wrapper{background:#fff;padding:16px 16px 0;margin-bottom:32px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04);box-shadow:0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04)}.dashboard-editor-container .chart-wrapper .chart-title{text-align:center;font-weight:bold;padding-bottom:25px}@media(max-width: 1024px){.chart-wrapper{padding:8px}}", ""]);

// exports
